
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface PatientDentalProblemParameter  extends Parameter {

    searchTerm: number;
    orderBy: string;

}
export interface PatientDentalProblem {

    id?: number;
    problemNotes: string;   
    problemId: any;

   
    visitId:any;
    regId: string;     
    tenantId: any;
    branchId: any;
    //Log
    createdDate?:Date;
    updatedDate?:Date;
    createdBy?:number;
    updatedBy?:number;
    createdIP?:string;
    updatedIP?:string;
    parameters?: PatientDentalProblemParameter[];
    links?: any;

}


export abstract class PatientDentalProblemData { 

    abstract list(url: string): Observable<PatientDentalProblem[]>;
    abstract create(url: string, data: PatientDentalProblem): Observable<any>;
    abstract update(url: string, data: PatientDentalProblem): Observable<any>;
    abstract delete(url: string): Observable<any>; 
   
}
